import Group from './Group'
import Item from './Item'
import Section from './Section'
import LinkLabel from './LinkLabel'
import Banner from './Banner'
import Icon from './Icon'
import Img from './Img'

import './styles.scss'

const Box = {
    Group, Item, Section, LinkLabel, Banner, Icon, Img
}

export default Box